import { render, staticRenderFns } from "./RunComparison.vue?vue&type=template&id=27d23ec9&"
import script from "./RunComparison.vue?vue&type=script&lang=js&"
export * from "./RunComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports